<section class="sanofi-statementsList my-4">
  <div class="sanofi-statementsList__tableHeader container py-3">
    <div class="sanofi-statementsList__tableHeaderRow row d-none d-lg-flex">
      <div class="sanofi-statementsList__tableHeaderCell"
           [ngClass]="{
              'col-8': !widgetView(),
              'col-7': widgetView()
           }"
      >
        {{ 'statements.tableHeader.period' | cxTranslate }}
      </div>
      <div class="sanofi-statementsList__tableHeaderCell"
           [ngClass]="{
              'col-2': !widgetView(),
              'col-3': widgetView()
           }"
      >
        {{ 'statements.tableHeader.view' | cxTranslate }}
      </div>
      <div class="sanofi-statementsList__tableHeaderCell col-2">{{ 'statements.tableHeader.download' | cxTranslate }}</div>
    </div>
  </div>
  <div class="sanofi-statementsList__tableBody container">
    @if (isLoading()) {
      <cx-spinner class="sanofi-statementsList__spinner"/>
    } @else {
      @for (statement of statementsList(); track statement.value) {
        <div class="sanofi-statementsList__tableRow row flex-column flex-lg-row py-3">
          <div class="sanofi-statementsList__tableCell col-12 d-flex"
               [ngClass]="{
                  'col-lg-8': !widgetView(),
                  'col-lg-7': widgetView()
               }"
          >
            <div class="sanofi-statementsList__tableHeaderCell d-lg-none mr-3 my-2">{{ 'statements.tableHeader.period' | cxTranslate }}:</div>

            <span>{{ statement?.value | date : 'MM/dd/yyyy' }}</span>
          </div>

          <div class="sanofi-statementsList__tableCell col-12 d-flex"
               [ngClass]="{
                  'col-lg-2': !widgetView(),
                  'col-lg-3': widgetView()
               }"
          >
            <div class="sanofi-statementsList__tableHeaderCell d-lg-none mr-3 my-2">{{ 'statements.tableHeader.view' | cxTranslate }}:</div>
            <button class="c-button c-button--link-primary text-decoration-none text-left px-0" (click)="openStatements(statement)">
              <img src="icons/document_icon.svg" alt="View statement detail" class="sanofi-statementsList__viewDetailsIcon mr-1">
              {{ 'statements.statementList.view_text' | cxTranslate }}
            </button>
          </div>

          <div class="sanofi-statementsList__tableCell col-12 col-lg-2 d-flex">
            <div class="sanofi-statementsList__tableHeaderCell d-lg-none mr-3 my-2">{{ 'statements.tableHeader.download' | cxTranslate }}:</div>
            <sanofi-statements-pdf-download
              [accountNumber]="accountId()"
              [isCustomerEmulated]="isCustomerEmulated()"
              [toDate]="statement.value"
              [salesOrg]="salesOrg()"
              class="statementsFileDownload"
            />
          </div>
        </div>
      }

      <sanofi-no-items-disclaimer
        [itemsList]="statementsList()"
        [text]="'statements.noStatements' | cxTranslate"
        [mix]="'sanofi-statementsList__tableRow'"
      />
    }
  </div>
</section>
